import Vue from 'vue';
import Router from 'vue-router'
import axios from 'axios';
import apiUrl from '../constants';
// Containers
import Full from '@/containers/Full';
import 'vue-search-select/dist/VueSearchSelect.css';
// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome';
import SimpleLineIcons from '@/views/icons/SimpleLineIcons';
import CryptoJS from 'crypto-js';
// Views - Pages
import Login from '@/views/components/login';
 import changepassword from '@/views/components/changepassword';
import ClientDashborad from '@/views/components/cargoclient/clientdashboard';
import Approvalflow from '@/views/components/cargoclient/approvalflow';
import Approvethank from '@/views/components/cargoclient/approvalflow/approvethank';
import ClientManagementRoutes from '@/modules/clientmanagement/router';
import MasterDataRoutes from '@/modules/masterdata/router';
import Reporting from '@/modules/reporting/router';
import Requests from '@/modules/requests/views/approvalrequest';
import CargoAllocationRoutes from '@/modules/cargoallocation/router';
import CargoBookingRoutes from '@/modules/cargobooking/router';
import firstAndLastmilemanagement from '@/modules/firstAndLastmilemanagement/router';
import AdminSettingsRoutes from '@/modules/adminsettings/router';
import report from '@/modules/report/router';
import utility from '@/modules/utility/router';
import Page404 from '@/modules/pages/Page404';

Vue.use(Router)
const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: '/',
      redirect: '/dashboard',
      component: Full,
      children: [
        ...ClientManagementRoutes,
        ...MasterDataRoutes,
        ...Reporting,
        ...CargoAllocationRoutes,
        ...CargoBookingRoutes,
        ...firstAndLastmilemanagement,
        ...AdminSettingsRoutes,
        ...report,
        ...utility,
        {
          path: '/changepassword',
          name: 'Change Password',
          component: changepassword,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/dashboard'
              },
              {
                name: 'Change Password'
              }
            ]
          }
        },
        {
          path: '/cargoclient/clientdashboard',
          name: 'Client Dashboard',
          component: ClientDashborad,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/cargoclient/clientdashboard'
            }]
          },
        },
        {
          path: '/approval',
          name: 'Approval Flow',
          component: Requests,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/cargoclient/clientdashboard'
              },
              {
                name: 'Approval Flow'
              }
            ]
          }
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        }
      ]
    },
    {
      path: '/login/:id?',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
            path: '404',
            name: 'Page404',
            component: Page404
        },
        {
          path: '/approvethank/:accept/:encryiptedJSON',
          name: 'approvethank',
          component: Approvethank,
          meta: {
            //requiresAuth: true,
          }
        },
      ]
    },
  ]
});
import keycloak from '../keycloack';
router.beforeEach(async (to, from, next) => {
  try{
  var isLoggedIn = window.localStorage.getItem('isLoggedIn');
  let checkedToken = await keycloak.checktoken();
  console.log(checkedToken)
  if (isLoggedIn == null || !isLoggedIn || checkedToken) {
    isLoggedIn = false;
    // localStorage.removeItem('permissiondata')
    // localStorage.removeItem('userdetail')
    // localStorage.removeItem('userToken')
    localStorage.removeItem('isLoggedIn')
    // localStorage.removeItem('cargoAutoaccesspermissiondata')
    // localStorage.removeItem('cargoAutoaccessuserdata')
    let auth = await keycloak.init({ onLoad: 'login-required' });
    if (auth) {
      window.localStorage.setItem("userToken", keycloak.token);
      window.localStorage.setItem('isLoggedIn', true);
      window.localStorage.setItem('refreshToken', keycloak.refreshToken);
      if ((to.fullPath.split('&state').length>1 && to.fullPath.split('&state')[0][1]) && window.localStorage.getItem('cargoAutoaccesspermissiondata') !== null && window.localStorage.getItem('cargoAutoaccessuserdata') !== null) {
        let topath = to.fullPath.split('&state')[0]
        next({ path: topath})
      } else {
      next({ path: '/login' });
      }
      return;
    } else {
      window.location.reload();
    }
  } else {
    isLoggedIn = true;
  }

  if (isLoggedIn == true) {
    let unauthorizeVal = false;
    let userToken = window.localStorage.getItem('userToken');
    let myStr = null;
    if (userToken != null) {
      myStr = userToken.replace(/"/g, '');
    }
    axios({
        method: 'POST',
        'url': apiUrl.api_url + 'appvalidatetoken',
        'data': {},
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
      .then((response) => {
        if (response.data == false) {
          localStorage.removeItem('cargoAutoaccesspermissiondata');
          localStorage.removeItem('cargoAutoaccessuserdata');
          localStorage.removeItem('userToken');
          localStorage.setItem('removedtoken1', 'router.beforeEach.appvalidation')
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('serverdate');
          localStorage.clear()
          sessionStorage.clear()
          console.log("Error code - R218 -  Something went wrong. Please try after sometime");
          keycloak.logoutWithoutTokenId()
        }else{
          window.localStorage.setItem('serverdate',response.data);
        }
      }, (error) => {
        localStorage.removeItem('cargoAutoaccesspermissiondata');
        localStorage.removeItem('cargoAutoaccessuserdata');
        localStorage.removeItem('userToken');
        localStorage.setItem('removedtoken3', 'router3.beforeEach.appvalidation.catch')
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('serverdate');
        localStorage.clear()
        sessionStorage.clear()
        console.log("Error code - R234 - Something went wrong. Please try after sometime.");
        keycloak.logoutWithoutTokenId()
      });
  }

  //next();
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({
      path: "/",
    });
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const permissionEncrypt = window.localStorage.getItem('cargoAutoaccesspermissiondata')
      const bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
      const plaintext = bytes.toString(CryptoJS.enc.Utf8);
      const permissiondata = JSON.parse(plaintext);

      function isBigEnough(findURL) {
      if (findURL.children.length > 0) {
        let flag = 0;
        for (let i = 0; i < findURL.children.length; i++) {
          if(findURL.children[i].children.length>0){
            flag =  findURL.children[i].children.some(isBigChildEnough);
            if(flag) break;
          }
        }
        if (flag) return flag;
        return findURL.children.some(isBigChildEnough);
      }
      return findURL.url == to.path;
    }

      function isBigChildEnough(findURL) {

        return findURL.url == to.path;
      }

      const setroles = permissiondata.some(isBigEnough)
      if (setroles) {
        next();
      } else {
        let redirecturl = permissiondata[0].url;
        next({
          path: redirecturl,
        });
      }
    } else {
      next();
    }
  }}
  catch (err) {
    console.log(err)
    localStorage.removeItem('permissiondata')
    localStorage.removeItem('userdetail')
    localStorage.removeItem('userToken')
    localStorage.setItem('removedtoken2', 'router.beforeEach.appvalidation.catch')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('cargoAutoaccesspermissiondata')
    localStorage.removeItem('cargoAutoaccessuserdata')
    localStorage.clear()
    sessionStorage.clear()
    console.log("Error code - R297 - Something went wrong. Please try after sometime.");
    keycloak.logoutWithoutTokenId()
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js